<template>
  <div>
    <!-- Hack to cover left sidebar -->
    <v-overlay class="sidebar-cover-overlay" v-if="modal.visible">
      <div class="sidebar-cover-clickable"></div>
    </v-overlay>

    <v-dialog v-model="modal" persistent :width="600">
      <v-card>
        <v-card-title> Share Saved Query: {{ savedSearch.name }} </v-card-title>
        <v-card-subtitle>
          Please note that removing a colleague will unshare the Saved Query.
        </v-card-subtitle>
        <v-container class="mt-0 pt-0">
          <v-row v-if="message">
            <v-col>
              {{ message }}
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <UserShareListEditor
                :value="sharedList"
                :init="sharedWithInit"
                :return-object="!isSavedSearchNewApiFeatureUnlocked"
                :allow-empty="true"
                width-class-name="col-11"
                class="hyp-shared-listing mt-3"
                @input="handleChangeSharedList"
              ></UserShareListEditor>
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>
          <v-btn
            color="primary"
            :disabled="loading"
            class="mr-2"
            @click="handleClickSave"
            >Save
            <v-progress-circular
              v-if="loading"
              indeterminate
              size="14"
              width="2"
              class="ml-2"
            ></v-progress-circular>
          </v-btn>

          <v-btn text @click="handleClickCancel">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import lodashCloneDeep from "lodash/cloneDeep";
import lodashDebounce from "lodash/debounce";

import {
  updateSearchQuery,
  shareSearchQuery,
} from "@/services/search/savedSearch.service";
import { NOTIFICATION_ID_PROPERTY } from "@/common/constants/notifications";

const EMITTED_ACTIONS = {
  CLOSE: "close",
};

export default {
  name: "SearchUserShareModal",
  components: {
    UserShareListEditor: () =>
      import("@/components/alerts/wizard/userShareList/UserShareListEditor"),
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    savedSearch: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      modal: false,
      sharedList: [],
      sharedWithInit: new Date().toISOString(),
      loading: false,
      refresh: null,
      success: true,
      message: false,
    };
  },
  computed: {
    isSavedSearchNewApiFeatureUnlocked() {
      return this.featureUnlocked("saved-search-new-api");
    },
  },
  methods: {
    closeModal(emit) {
      this.message = null;
      this.loading = false;
      this.sharedList = [];
      this.modal = false;
      this.$emit(EMITTED_ACTIONS.CLOSE);
    },
    handleClickCancel() {
      this.closeModal();
    },
    handleChangeSharedList(value) {
      this.sharedList = value;
    },
    async handleClickSave() {
      this.message = null;
      const savedSearch = lodashCloneDeep(this.savedSearch);
      savedSearch.shared_list = this.sharedList;
      savedSearch.sharedList = this.sharedList;
      try {
        this.loading = true;
        if (this.isSavedSearchNewApiFeatureUnlocked) {
          this.success = await shareSearchQuery({
            id: savedSearch.id,
            sharedWith: savedSearch.sharedList,
          });
        } else {
          this.success = await updateSearchQuery({
            id: this.savedSearch[NOTIFICATION_ID_PROPERTY],
            data: savedSearch,
          });
        }

        if (!this.success) {
          this.loading = false;
          this.message = "There was an issue sharing, please try again.";
        } else {
          lodashDebounce(() => {
            this.message = null;
            this.loading = false;
            this.closeModal();
          }, 1000)();
        }
      } catch (error) {
        console.error("There was an error when saving the query: " + error);
      }
    },
  },
  watch: {
    open: {
      handler() {
        this.modal = this.open;
      },
    },
    savedSearch: {
      handler() {
        this.sharedList = this.isSavedSearchNewApiFeatureUnlocked
          ? this.savedSearch.sharedWith
          : this.savedSearch.sharedList;
        this.sharedWithInit = new Date().toISOString();
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped></style>
